import { SVGProps, memo } from 'react';

const MobileIcon = (props: SVGProps<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillOpacity="0"
        d="M0 0H24V24H0z"
        transform="translate(-1362 -1765) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(24 24) translate(0 78) translate(230)"
      />
      <path
        fill="#666869"
        d="M9.5 20h5c.276 0 .5.224.5.5s-.224.5-.5.5h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5zm7.5 2H7V2h3c0 .552.447 1 1 1h2c.553 0 1-.448 1-1h3v20zm0-22H7C5.896 0 5 .896 5 2v20c0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2V2c0-1.104-.896-2-2-2z"
        transform="translate(-1362 -1765) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(24 24) translate(0 78) translate(230)"
      />
    </g>
  </svg>
);

export default memo(MobileIcon);
